import axios from 'axios';
import { Config } from '../config';
import { EntryDto, EntrySearchDto } from '@/model/entry.dto';

export class EntryApi {
  public async getEntryNum(
    accessToken: string,
    dto: EntrySearchDto,
  ): Promise<EntryDto[]> {
    const url = `${Config.API_URL}/console/access/entry/count`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    const params = dto;
    const res = await axios.get(url, { headers, params });
    return res.data;
  }
  public async getEntryList(
    accessToken: string,
    dto: EntrySearchDto,
  ): Promise<EntryDto[]> {
    const url = `${Config.API_URL}/console/access/entry/period`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    const params = dto;
    const res = await axios.get(url, { headers, params });
    return res.data;
  }
  public async getEntryDetailList(
    accessToken: string,
    dto: EntrySearchDto,
  ): Promise<EntryDto[]> {
    const url = `${Config.API_URL}/console/access/entry/period/detail`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    const params = dto;
    const res = await axios.get(url, { headers, params });
    return res.data;
  }
}
